// ABOUTME: Configuration for the Software News management page tabs.
// ABOUTME: Two tabs — news articles and meldingen — both authored from this page.

import NewspaperIcon from '@mui/icons-material/Newspaper';
import CampaignIcon from '@mui/icons-material/Campaign';

export const softwareNewsConfig = {
    all: {
        title: 'news',
        icon: <NewspaperIcon />,
    },
    meldingen: {
        title: 'meldingen',
        icon: <CampaignIcon />,
    },
};
